import { cn } from "@/lib/utils";

const statusConfig: Record<SwapStatus, { label: string; className: string }> = {
  pending: {
    label: "Pending",
    className: "text-[#FFB84D]",
  },
  processing: {
    label: "Processing",
    className: "text-[#7DA2FF]",
  },
  completed: {
    label: "Completed",
    className: "text-[#4ED79D]",
  },
  refunded: {
    label: "Refunded",
    className: "text-[#4ED79D]",
  },
  failed: {
    label: "Failed",
    className: "text-[#FF6E7A]",
  },
};

const SwapStatusBadge = ({
  status,
  className,
}: {
  status: SwapStatus;
  className?: string;
}) => {
  const config = statusConfig[status];
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-3 py-1.5 text-xs font-medium whitespace-nowrap",
        config.className,
        className,
      )}
    >
      {config.label}
    </span>
  );
};

export default SwapStatusBadge;
